import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { Tag } from '@/components/elements'
import { TAX_TYPE, TAX_TYPE_LABEL, type TaxType } from '@/libs/api/types'

type StatusTagProps = ComponentPropsWithoutRef<typeof Tag>
type TagColor = StatusTagProps['color']

type Props = ComponentPropsWithoutRef<'div'> & {
  taxType: TaxType
}

const TAG_COLOR_MAP: Record<TaxType, TagColor> = {
  [TAX_TYPE.NON_TAXABLE]: 'gray-2',
  [TAX_TYPE.TAXABLE]: 'primary'
}

/**
 * 税区分の種別Tag
 */
export const TaxTypeTag: FC<Props> = ({ className, taxType, ...props }) => {
  return (
    <Tag
      {...props}
      className={clsx(['min-w-[58px] text-[13px]', className])}
      size="small"
      color={TAG_COLOR_MAP[taxType]}
    >
      {TAX_TYPE_LABEL[taxType]}
    </Tag>
  )
}
